import Cookies from 'js-cookie'
import {COOKIE, HOME_HREF, RUSSIA_PARTNER_SITE, TURKEY_PARTNER_SITE} from '../constants'

export const PARTNER_SHIP_TO_COUNTRIES = ['TR', 'RU']

export const persistShipToCountryCookies = (countryCode, accepted = false) => {
    if (!countryCode || PARTNER_SHIP_TO_COUNTRIES.includes(countryCode)) return

    Cookies.set(COOKIE.SHIP_TO_COUNTRY, countryCode, {
        expires: 365,
        path: '/',
        sameSite: 'Lax'
    })

    if (accepted) {
        Cookies.set(COOKIE.SHIP_TO_COUNTRY_ACCEPTED, countryCode, {
            expires: 365,
            path: '/',
            sameSite: 'Lax'
        })
    }
}

export const getShipToCountryChangeTarget = ({
    selectedCountryCode,
    siteAlias,
    isOutletSite,
    buildUrl,
    preferredLocale
}) => {
    if (selectedCountryCode === 'US' && ['eu', 'outlet-eu'].includes(siteAlias)) {
        const targetSiteAlias = isOutletSite ? 'outlet-us' : 'us'

        return {
            type: 'siteSwitch',
            href: buildUrl(
                HOME_HREF + `?country=${selectedCountryCode}`,
                targetSiteAlias,
                preferredLocale
            ),
            targetSiteAlias
        }
    }

    if (
        selectedCountryCode !== 'US' &&
        !PARTNER_SHIP_TO_COUNTRIES.includes(selectedCountryCode) &&
        ['us', 'outlet-us'].includes(siteAlias)
    ) {
        const targetSiteAlias = isOutletSite ? 'outlet-eu' : 'eu'

        return {
            type: 'siteSwitch',
            href: buildUrl(
                HOME_HREF + `?country=${selectedCountryCode}`,
                targetSiteAlias,
                preferredLocale
            ),
            targetSiteAlias
        }
    }

    if (selectedCountryCode === 'TR') {
        return {
            type: 'partner',
            href: TURKEY_PARTNER_SITE,
            targetSiteAlias: null
        }
    }

    if (selectedCountryCode === 'RU') {
        return {
            type: 'partner',
            href: RUSSIA_PARTNER_SITE,
            targetSiteAlias: null
        }
    }

    return {
        type: 'sameSite',
        href: null,
        targetSiteAlias: null
    }
}
